import { render } from "./JourneyHeader.vue?vue&type=template&id=42529483"
import script from "./JourneyHeader.vue?vue&type=script&lang=js"
export * from "./JourneyHeader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__